/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderFormSchemaFactory, BuilderUserContext, FormRootSchema } from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { FormState, FormStateSchema, whenCreateOrEditMode } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { constant, mapValues } from 'lodash';
import { OfficeRoleTodoPermissions } from '../../../resources/office-role-todo-permission.model';

@Injectable()
export class OfficeRoleTodoPermissionTabFormState extends FormState<OfficeRoleTodoPermissions> {
  constructor(schemaFactory: BuilderFormSchemaFactory,
              private userContext: BuilderUserContext) {
    super(schemaFactory);
  }

  protected buildSchema(permissions: OfficeRoleTodoPermissions, { root }: FormStateSchema): FormRootSchema {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.Manager.Roles.Permissions.EDIT) ?
      FormMode.EditMode : FormMode.ViewMode;

    return root({
      mode,
      enabled: whenCreateOrEditMode(),
      children: mapValues(permissions, constant(void 0)),
    });
  }
}
